import { render, staticRenderFns } from "./TransferAssetsToWalletModal.vue?vue&type=template&id=0e5dd419&scoped=true&"
import script from "./TransferAssetsToWalletModal.vue?vue&type=script&lang=js&"
export * from "./TransferAssetsToWalletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5dd419",
  null
  
)

export default component.exports